import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, MenuItem, TableRow, Table, TableHead, TableBody, TableContainer, Paper, TableCell, Card, Box, Typography, IconButton, FormHelperText, Tooltip, TextField, InputAdornment, LinearProgress, CircularProgress } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import ImageIcon from '@material-ui/icons/Image';
import VideocamIcon from '@material-ui/icons/Videocam';
import { getDashboardPageStyles } from "../../utils/dashboardPageStyles";
import SchoolIcon from '@material-ui/icons/School';
import SuperActivityService from "./Locality/Service/superActivityService";
import SubActivityService from "./Locality/Service/subActivityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import ImagesStoreService from "./Locality/Service/imagesStoreService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, Chip } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import { styled } from '@material-ui/styles';

import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import { canEditDeleteActivityRow } from "../../utils/activityRowPermissions";
import { buildListSchoolRequest, buildScopedListBody, buildCatalogListBody, effectiveSchoolIdForWrite, filterRowsBySchoolScope, getUserDetails, resolveRowSchoolId, resolveSchoolId, resolveSchoolIdForClass, resolveRowSchoolLabel, resolveSchoolLabel, resolveCatalogFormSchooleId, resolveCatalogWriteSchooleId, normalizeId, isSchoolAddedRow, shouldShowSchoolColumn, dedupeSuperActivitiesForFilter, filterRowsBySuperActivity, filterRowsByClassId, filterRowsByCatalogType, parseCatalogListResponse, SUPER_ACTIVITY_DROPDOWN_FIELDS, ACTIVITY_DROPDOWN_FIELDS } from "../../utils/activityCatalogScope";

const MAX_EXERCISE_IMAGES = 10;
const MAX_EXERCISE_VIDEOS = 5;
const MAX_VIDEO_SIZE_MB = 200;
const MAX_VIDEO_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;
const CONTENT_EXCLUSIVE_HINT =
    'Notes, images and videos can be set on either List of Activities or Exercises, not both.';

const hasCatalogContent = (row) => {
    if (!row) return false;
    if (String(row.notes || '').trim()) return true;
    if (Array.isArray(row.imageURL) && row.imageURL.filter(Boolean).length) return true;
    if (Array.isArray(row.videoURL) && row.videoURL.filter(Boolean).length) return true;
    return false;
};

const useStyles = makeStyles((theme) => ({
    ...getDashboardPageStyles(theme),
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dialogPaper: {
        borderRadius: 14,
        width: 520,
        maxWidth: '95vw',
    },
    dialogTitleBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #eef1f5',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.15rem',
        color: '#0f2d4d',
    },
    dialogBody: {
        padding: theme.spacing(2.5),
    },
    fieldLabel: {
        display: 'block',
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#46566b',
        marginBottom: 6,
    },
    dialogFooter: {
        padding: theme.spacing(1.5, 2.5),
        borderTop: '1px solid #eef1f5',
    },
    cancelBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#46566b',
    },
    saveBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        backgroundColor: '#1769d6',
        color: '#fff',
        boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
        '&:hover': { backgroundColor: '#125bbd' },
        '&:disabled': { color: '#fff', opacity: 0.65 },
    },
    mediaHint: {
        fontSize: '0.72rem',
        color: '#7a8aa0',
        marginBottom: 8,
    },
    mediaActions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        marginBottom: 10,
    },
    mediaPickBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        borderColor: '#1769d6',
        color: '#1769d6',
    },
    mediaPreviewGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
    },
    mediaPreviewItem: {
        position: 'relative',
        width: 88,
    },
    mediaThumb: {
        width: 88,
        height: 88,
        objectFit: 'cover',
        borderRadius: 8,
        border: '1px solid #e6eaf0',
        display: 'block',
        backgroundColor: '#f8fafc',
    },
    mediaRemoveBtn: {
        position: 'absolute',
        top: 2,
        right: 2,
        backgroundColor: 'rgba(255,255,255,0.95)',
        padding: 3,
        '&:hover': { backgroundColor: '#fff' },
    },
    uploadProgressWrap: {
        marginTop: 8,
        marginBottom: 4,
    },
    exclusiveWarnBox: {
        marginBottom: theme.spacing(1.5),
        padding: theme.spacing(1.25, 1.5),
        borderRadius: 10,
        backgroundColor: '#fff8e6',
        border: '1px solid #ffe4a3',
    },
    exclusiveWarnText: {
        color: '#7a5c00',
        fontSize: '0.8rem',
        lineHeight: 1.5,
    },
    emptyFilterBox: {
        marginTop: theme.spacing(1.5),
        padding: theme.spacing(1.25, 1.5),
        borderRadius: 10,
        backgroundColor: '#fff8e6',
        border: '1px solid #ffe4a3',
    },
    emptyFilterText: {
        color: '#7a5c00',
        fontSize: '0.875rem',
        lineHeight: 1.55,
    },
    placeholderText: {
        color: '#94a3b8',
        fontStyle: 'italic',
        fontSize: '0.875rem',
    },
}));
const buildExercisePlaceholder = (classId, className, activity, area) => ({
    _id: `placeholder-${activity?._id || area?._id || 'area'}`,
    isPlaceholder: true,
    classId: { _id: classId, className: className || '' },
    activityId: activity ? {
        _id: activity._id,
        activityName: activity.activityName,
        superActivityId: area || activity.superActivityId,
    } : {
        activityName: '',
        superActivityId: area,
    },
    subActivityName: '',
});
export default function SubActivity({ embedded = false, scope = null, sharedClassList = null, sharedSchoolList = null, active = true }) {
    const tableHeaders = ['Class', 'Area Of Work', 'List Of Activities', 'Exercise', 'Add More', 'Actions'];
    const classes = useStyles();
    const userDetails = useMemo(
        () => scope?.userDetails || getUserDetails(),
        [scope]
    );
    const useExternalScope = embedded && scope != null;
    const serverPaginated = useExternalScope;
    const scopeSchoolId = scope?.filterSchoolId ?? '';
    const scopeClassId = scope?.filterClassId ?? '';
    const scopeCatalogType = scope?.catalogType || 'indian';
    const [filterActivity, setfilterActivity] = useState('');
    const [filterSuperActivity, setFilterSuperActivity] = useState('');
    const [filterSuperActivityList, setFilterSuperActivityList] = useState([]);
    const [filterActivityList, setFilterActivityList] = useState([]);
    const [filterExercise, setExercise] = useState('');
    const [filterExerciseList, setExerciseList] = useState([]);
    const [subActivitylList, setSubActivityList] = useState([]);
    const [temSubActivitylList, setTempSubActivityList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [addActivityList, setAddActivityList] = useState([]);
    
    const [subActivityIdList, setSubActivityIdList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [open, setOpen] = React.useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(embedded ? 10 : 1000);
    const [pagedRows, setPagedRows] = useState([]);
    const [pagedTotal, setPagedTotal] = useState(0);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [addClassList, setAddClassList] = useState([]);
    const [addSchoolList, setAddSchoolList] = useState([]);
    // SUPERADMIN can explicitly pick which school an exercise belongs to
    // (in the Add/Edit dialog) instead of relying only on the top scope filter.
    const isSuperAdminScope = Boolean(useExternalScope && scope?.isSuperAdmin);
    var [classId, setClassId] = useState("");
    const effectiveClassId = useExternalScope ? scopeClassId : classId;
    const [subActivity, setSubActivity] = useState({
        classId: '',
        superActivityId: '',
        activityId: '',
        subActivityName: '',
        upload: '',
        notes: '',
        imageURL: [],
        videoURL: [],
        schooleId: '',
        catalogType: scopeCatalogType,
    });
    const [viewOpen, setViewOpen] = useState(false);
    const [viewRow, setViewRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [mediaUploading, setMediaUploading] = useState(false);
    const [mediaUploadProgress, setMediaUploadProgress] = useState({ percent: 0, message: '' });
    const [parentActivityHasContent, setParentActivityHasContent] = useState(false);
    const imageInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        subActivityName: Yup.string(),
        upload: Yup.string(),
    });
    useEffect(() => {
        getSubList();
        getActivityList();
        if (!sharedClassList) {
            getAddClassList();
        }
        return () => {
            setSubActivityIdList([]);
            setActivityList([]);
            setSubActivityList([]);
            setTempSubActivityList([]);
            setAddSuperActivityList([]);
        }
    }, [scopeSchoolId, scopeClassId, scopeCatalogType, useExternalScope, sharedClassList]);

    useEffect(() => {
        if (sharedClassList) {
            setAddClassList(sharedClassList);
        }
    }, [sharedClassList]);

    useEffect(() => {
        if (sharedSchoolList) {
            setAddSchoolList(sharedSchoolList);
        }
    }, [sharedSchoolList]);

    useEffect(() => {
        if (!useExternalScope) return;
        setFilterSuperActivity('');
        setfilterActivity('');
        setExercise('');
        setpg(0);
    }, [scopeSchoolId, scopeClassId, useExternalScope]);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(searchTerm), 400);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        if (!serverPaginated) return;
        setpg(0);
    }, [debouncedSearch, filterSuperActivity, filterActivity, filterExercise, serverPaginated]);
    const handleOpen = (status) => {
        if (status) {
            const nextClassId = useExternalScope ? (effectiveClassId || '') : '';
            setParentActivityHasContent(false);
            setSubActivity({
                classId: nextClassId,
                superActivityId: '',
                activityId: '',
                subActivityName: '',
                upload: '',
                notes: '',
                imageURL: [],
                videoURL: [],
                schooleId: isSuperAdminScope
                    ? (scopeSchoolId || '')
                    : resolveSchoolIdForClass(
                        addClassList,
                        nextClassId,
                        useExternalScope ? scopeSchoolId : '',
                        userDetails
                    ),
                catalogType: scopeCatalogType,
            })
        }

        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setParentActivityHasContent(false);
        setMediaUploading(false);
        setMediaUploadProgress({ percent: 0, message: '' });
    };

    const checkParentActivityContent = useCallback(async (activityId) => {
        if (!activityId) {
            setParentActivityHasContent(false);
            return false;
        }
        try {
            const parent = await ActivityTabelService.getActivityTabelById(activityId);
            const blocked = hasCatalogContent(parent);
            setParentActivityHasContent(blocked);
            return blocked;
        } catch {
            setParentActivityHasContent(false);
            return false;
        }
    }, []);

    const activityIdOf = (act) => {
        const a = act.activityId;
        if (!a) return "";
        return a._id != null ? a._id : a;
    };

    const superActivityIdOf = (act) => {
        const sa = act.activityId?.superActivityId || act.superActivityId;
        if (!sa) return "";
        return sa._id != null ? sa._id : sa;
    };

    const loadFilterSuperActivities = useCallback((nextClassId) => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) {
            setFilterSuperActivityList([]);
            return;
        }
        const applyAreas = (res) => {
            let rows = filterRowsBySchoolScope(
                Array.isArray(res) ? res : [],
                useExternalScope ? scopeSchoolId : '',
                useExternalScope ? scopeCatalogType : undefined
            );
            if (useExternalScope) {
                rows = filterRowsByCatalogType(rows, scopeCatalogType);
            }
            setFilterSuperActivityList(
                nextClassId ? rows : dedupeSuperActivitiesForFilter(rows)
            );
        };
        const listBody = useExternalScope
            ? buildCatalogListBody(listId, {
                classId: nextClassId || scopeClassId || '',
                catalogType: scopeCatalogType,
              })
            : {};
        const dropdownFields = { fields: SUPER_ACTIVITY_DROPDOWN_FIELDS };
        if (nextClassId) {
            SuperActivityService.getAllSuperActivityById(
                listId,
                { ...listBody, classId: nextClassId },
                role,
                dropdownFields
            )
                .then(applyAreas)
                .catch(() => setFilterSuperActivityList([]));
            return;
        }
        SuperActivityService.getAllSuperActivity(listId, role, listBody, dropdownFields)
            .then(applyAreas)
            .catch(() => setFilterSuperActivityList([]));
    }, [userDetails, useExternalScope, scopeSchoolId, scopeClassId, scopeCatalogType]);

    const loadFilterActivities = useCallback((nextClassId, nextSuperActivityId) => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) {
            setFilterActivityList([]);
            return;
        }
        const applyActivities = (res) => {
            let rows = filterRowsBySchoolScope(
                Array.isArray(res) ? res : [],
                useExternalScope ? scopeSchoolId : '',
                useExternalScope ? scopeCatalogType : undefined
            );
            if (useExternalScope) rows = filterRowsByCatalogType(rows, scopeCatalogType);
            if (nextClassId) rows = filterRowsByClassId(rows, nextClassId);
            if (nextSuperActivityId) rows = filterRowsBySuperActivity(rows, nextSuperActivityId);
            setFilterActivityList(rows);
        };
        const listBody = useExternalScope
            ? buildCatalogListBody(listId, {
                classId: nextClassId || scopeClassId || '',
                catalogType: scopeCatalogType,
              })
            : {};
        const dropdownFields = { fields: ACTIVITY_DROPDOWN_FIELDS };
        if (!nextClassId && !nextSuperActivityId) {
            ActivityTabelService.getAllActivityTabel(listId, role, listBody, dropdownFields)
                .then(applyActivities)
                .catch(() => setFilterActivityList([]));
            return;
        }
        const body = {
            ...buildCatalogListBody(listId, {
                classId: nextClassId || scopeClassId || '',
                catalogType: useExternalScope ? scopeCatalogType : undefined,
            }),
            ...(nextSuperActivityId ? { superActivityId: nextSuperActivityId } : {}),
        };
        ActivityTabelService.getAllActivityTabeBySuperActivityId(body, dropdownFields)
            .then(applyActivities)
            .catch(() => {
                ActivityTabelService.getAllActivityTabel(listId, role, listBody, dropdownFields)
                    .then(applyActivities)
                    .catch(() => setFilterActivityList([]));
            });
    }, [userDetails, useExternalScope, scopeSchoolId, scopeClassId, scopeCatalogType]);

    useEffect(() => {
        let list = filterRowsBySchoolScope(
            Array.isArray(temSubActivitylList) ? temSubActivitylList : [],
            useExternalScope ? scopeSchoolId : '',
            useExternalScope ? scopeCatalogType : undefined
        );
        if (useExternalScope) {
            list = filterRowsByCatalogType(list, scopeCatalogType);
        }
        let scoped = list;
        if (effectiveClassId) {
            const idStr = String(effectiveClassId);
            scoped = list.filter((act) => {
                const cid = act.classId && (act.classId._id != null ? act.classId._id : act.classId);
                return cid != null && String(cid) === idStr;
            });
        }
        if (filterSuperActivity) {
            const fsa = String(filterSuperActivity);
            scoped = scoped.filter((act) => String(superActivityIdOf(act)) === fsa);
        }
        if (filterActivity) {
            const fa = String(filterActivity);
            scoped = scoped.filter((act) => String(activityIdOf(act)) === fa);
        }
        setExerciseList(
            scoped.map((result) => ({ name: result.subActivityName, value: result._id }))
        );
        let displayRows = scoped;
        if (filterExercise) {
            const fe = String(filterExercise);
            displayRows = scoped.filter((act) => String(act._id) === fe);
        }
        setSubActivityList(displayRows);
    }, [effectiveClassId, temSubActivitylList, filterSuperActivity, filterActivity, filterExercise, useExternalScope, scopeSchoolId, scopeCatalogType]);

    useEffect(() => {
        loadFilterSuperActivities(effectiveClassId || null);
    }, [effectiveClassId, scopeSchoolId, loadFilterSuperActivities]);

    useEffect(() => {
        loadFilterActivities(effectiveClassId || null, filterSuperActivity || null);
    }, [effectiveClassId, filterSuperActivity, scopeSchoolId, loadFilterActivities]);

    const emptyExerciseMessage = useMemo(() => {
        const selectedClass = addClassList.find((c) => String(c._id) === String(effectiveClassId));
        const classLabel = selectedClass?.className || 'this class';
        const selectedArea = filterSuperActivityList.find(
            (area) => String(area._id) === String(filterSuperActivity)
        );
        const selectedActivity = filterActivityList.find(
            (activity) => String(activity._id) === String(filterActivity)
        );

        if (filterActivity && selectedActivity) {
            return `No exercises yet for "${selectedActivity.activityName}"${
                selectedArea ? ` in ${selectedArea.superActivityName}` : ''
            }${effectiveClassId ? ` (${classLabel})` : ''}. Use Add Exercise or + in Add More.`;
        }
        if (filterSuperActivity && selectedArea && filterActivityList.length > 0) {
            return `List activities exist for "${selectedArea.superActivityName}" in ${classLabel}, but no exercises yet. Use Add Exercise or + in Add More.`;
        }
        if (filterSuperActivity && selectedArea) {
            return `No list activities or exercises found for "${selectedArea.superActivityName}" in ${classLabel}. Add a list activity on the List Of Activities tab first.`;
        }
        if (effectiveClassId) {
            return `No exercises found for ${classLabel}. Try a different area of work or activity filter.`;
        }
        return 'No exercises found. Select a class or adjust your filters.';
    }, [
        effectiveClassId,
        filterSuperActivity,
        filterActivity,
        addClassList,
        filterSuperActivityList,
        filterActivityList,
    ]);

    const hasActiveFilters = Boolean(effectiveClassId || filterSuperActivity || filterActivity);
    const showSchoolColumn = shouldShowSchoolColumn(embedded, scope);
    const displayHeaders = useMemo(
        () => (showSchoolColumn ? ['School', ...tableHeaders] : tableHeaders),
        [showSchoolColumn]
    );

    const renderSchoolCell = (row) => {
        if (!isSchoolAddedRow(row)) {
            return <Typography variant="caption" style={{ color: '#9aa6b6' }}>Default</Typography>;
        }
        const label = resolveRowSchoolLabel(row, addClassList, addSchoolList);
        return label ? (
            <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={label} className={classes.classChip} />
        ) : (
            <Typography variant="caption" style={{ color: '#9aa6b6' }}>—</Typography>
        );
    };

    const tableRows = useMemo(() => {
        const selectedClass = addClassList.find((c) => String(c._id) === String(effectiveClassId));
        const classLabel = selectedClass?.className || '';
        const selectedArea = filterSuperActivityList.find(
            (area) => String(area._id) === String(filterSuperActivity)
        );

        if (!effectiveClassId) {
            return subActivitylList;
        }

        if (filterActivity) {
            if (subActivitylList.length > 0) return subActivitylList;
            const activity = filterActivityList.find((a) => String(a._id) === String(filterActivity));
            if (!activity) return [];
            return [buildExercisePlaceholder(effectiveClassId, classLabel, activity, selectedArea || activity.superActivityId)];
        }

        if (filterSuperActivity && filterActivityList.length > 0) {
            const exerciseActivityIds = new Set(
                subActivitylList.map((sub) => String(activityIdOf(sub))).filter(Boolean)
            );
            const placeholders = filterActivityList
                .filter((activity) => !exerciseActivityIds.has(String(activity._id)))
                .map((activity) => buildExercisePlaceholder(effectiveClassId, classLabel, activity, selectedArea));
            return [...subActivitylList, ...placeholders];
        }

        if (filterSuperActivity && selectedArea && subActivitylList.length === 0) {
            return [buildExercisePlaceholder(effectiveClassId, classLabel, null, selectedArea)];
        }

        return subActivitylList;
    }, [
        subActivitylList,
        effectiveClassId,
        filterActivity,
        filterSuperActivity,
        filterActivityList,
        filterSuperActivityList,
        addClassList,
    ]);

    const filteredTableRows = useMemo(() => {
        if (serverPaginated) {
            if (filterExercise) {
                return pagedRows.filter((row) => String(row._id) === String(filterExercise));
            }
            return pagedRows;
        }
        const term = searchTerm.trim().toLowerCase();
        if (!term) return tableRows;
        return tableRows.filter((row) => {
            const cls = (row.classId?.className || '').toLowerCase();
            const area = (row.activityId?.superActivityId?.superActivityName || '').toLowerCase();
            const activity = (row.activityId?.activityName || '').toLowerCase();
            const exercise = (row.subActivityName || '').toLowerCase();
            return cls.includes(term) || area.includes(term) || activity.includes(term) || exercise.includes(term);
        });
    }, [serverPaginated, pagedRows, filterExercise, tableRows, searchTerm]);

    const paginatedTableRows = serverPaginated
        ? filteredTableRows
        : filteredTableRows.slice(pg * rpg, pg * rpg + rpg);
    const paginationCount = serverPaginated
        ? (filterExercise ? filteredTableRows.length : pagedTotal)
        : filteredTableRows.length;

    const getSubList = () => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;
        const body = useExternalScope
            ? buildCatalogListBody(listId, {
                classId: effectiveClassId || '',
                catalogType: scopeCatalogType,
              })
            : {};
        SubActivityService.getAllSubActivity(listId, role, body).then((res) => {

            if (res) {
                const rows = filterRowsBySchoolScope(
                    Array.isArray(res) ? res : [],
                    useExternalScope ? scopeSchoolId : '',
                    useExternalScope ? scopeCatalogType : undefined
                );
                setTempSubActivityList(rows);
            }

        }).catch((err) => {

        });
    }

    // Backend-paginated fetch used for the rendered table in embedded (Activity
    // Catalog) mode. Runs alongside getSubList (which still feeds the Exercise
    // filter dropdown from the full unpaginated list) so existing dropdown /
    // placeholder behavior is untouched.
    const fetchPagedSubActivities = useCallback(() => {
        if (!serverPaginated) return;
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;
        const body = buildCatalogListBody(listId, {
            classId: effectiveClassId || '',
            catalogType: scopeCatalogType,
            superActivityId: filterSuperActivity || undefined,
            activityId: filterActivity || undefined,
        });
        SubActivityService.getAllSubActivity(listId, role, body, {
            page: pg,
            limit: rpg,
            search: debouncedSearch,
        }).then((res) => {
            const { rows, total } = parseCatalogListResponse(res);
            setPagedRows(rows);
            setPagedTotal(total);
        }).catch(() => {});
    }, [
        serverPaginated,
        userDetails,
        useExternalScope,
        scopeSchoolId,
        effectiveClassId,
        scopeCatalogType,
        filterSuperActivity,
        filterActivity,
        pg,
        rpg,
        debouncedSearch,
    ]);

    useEffect(() => {
        fetchPagedSubActivities();
    }, [fetchPagedSubActivities]);

    const getActivityList = (event, obj, overrideClassId) => {
        const { listId } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        const getsubActList = buildScopedListBody(listId, {
            classId: overrideClassId != null ? overrideClassId : formik.values.classId,
            superActivityId: event ? event.target.value : formik.values.superActivityId,
        });

        ActivityTabelService.getAllActivityTabeBySuperActivityId(
            getsubActList,
            { fields: ACTIVITY_DROPDOWN_FIELDS }
        ).then((res) => {
            setAddActivityList(
                useExternalScope ? filterRowsByCatalogType(res, scopeCatalogType) : res
            );
            if (obj) {
                setSubActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getAddClassList = (event) => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;
        AddClassService.getAllAddClass(listId, role).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (!useExternalScope && userDetails.classId) {
                setClassId(userDetails.classId);
              } else if (!useExternalScope) {
                setClassId("");
              }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editSubActivity = (sub) => {
        const obj = JSON.parse(JSON.stringify(sub));
        // SubActivity has no direct superActivityId field — it only lives nested
        // under activityId.superActivityId, so it must be derived (see superActivityIdOf).
        obj.superActivityId = superActivityIdOf(sub);
        obj.activityId = activityIdOf(sub);
        obj.classId = sub.classId ? (sub.classId._id || sub.classId) : '';
        obj.notes = sub.notes || '';
        obj.imageURL = Array.isArray(sub.imageURL) ? sub.imageURL.filter(Boolean) : [];
        obj.videoURL = Array.isArray(sub.videoURL) ? sub.videoURL.filter(Boolean) : [];
        obj.schooleId = isSuperAdminScope
            ? resolveCatalogFormSchooleId(sub)
            : (resolveRowSchoolId(sub) || resolveSchoolIdForClass(
                addClassList,
                obj.classId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            ));
        obj.catalogType = sub.catalogType || scopeCatalogType;

        getSuperActivityList({ target: { value: obj.classId } });
        getActivityList({ target: { value: obj.superActivityId } }, null, obj.classId);
        checkParentActivityContent(obj.activityId);

        setSubActivity(obj)
        handleOpen(false)
    }
    const addExerciseFromRow = (sub) => {
        const nextClassId = sub.classId ? (sub.classId._id || sub.classId) : '';
        const nextSuperActivityId = sub.activityId?.superActivityId
            ? (sub.activityId.superActivityId._id || sub.activityId.superActivityId)
            : (sub.superActivityId ? (sub.superActivityId._id || sub.superActivityId) : '');
        const nextActivityId = sub.activityId ? (sub.activityId._id || sub.activityId) : '';
        if (nextClassId) {
            getSuperActivityList({ target: { value: nextClassId } });
        }
        if (nextSuperActivityId) {
            getActivityList({ target: { value: nextSuperActivityId } }, null, nextClassId);
        }
        checkParentActivityContent(nextActivityId);
        setSubActivity({
            classId: nextClassId,
            superActivityId: nextSuperActivityId,
            activityId: nextActivityId,
            subActivityName: '',
            upload: '',
            notes: '',
            imageURL: [],
            videoURL: [],
            schooleId: isSuperAdminScope
                ? resolveCatalogFormSchooleId(sub)
                : (resolveRowSchoolId(sub) || resolveSchoolIdForClass(
                    addClassList,
                    nextClassId,
                    useExternalScope ? scopeSchoolId : '',
                    userDetails
                )),
            catalogType: sub.catalogType || scopeCatalogType,
        });
        setOpen(true);
    };
    const openView = (row) => {
        setViewRow(row || null);
        setViewOpen(true);
    };
    const closeView = () => {
        setViewOpen(false);
        setViewRow(null);
    };
    const deleteSubActivity = (subdelete) => {
        if (!subdelete) return;
        setPendingDelete(subdelete);
        setDeleteConfirmOpen(true);
    };

    // Tabs are kept mounted (hidden) after first visit; if the user leaves a
    // dialog open and switches away, close it so it doesn't linger (Material-UI
    // dialogs portal to document.body, so display:none on the hidden tab
    // wrapper alone would not hide them).
    useEffect(() => {
        if (active) return;
        setOpen(false);
        closeView();
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
    }, [active]);

    const confirmDelete = async () => {
        const row = pendingDelete;
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
        if (!row) return;
        try {
            await SubActivityService.deleteSubActivity(row);
            refreshExerciseCatalog();
        } catch {
            // ignore
        }
    };
    const refreshExerciseCatalog = () => {
        getSubActivityList();
        fetchPagedSubActivities();
    };
    const getSubActivityList = () => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        if (!listId) return;
        const body = useExternalScope
            ? buildCatalogListBody(listId, {
                classId: effectiveClassId || '',
                catalogType: scopeCatalogType,
              })
            : {};
        SubActivityService.getAllSubActivity(listId, role, body).then((res) => {
            const rows = filterRowsBySchoolScope(
                Array.isArray(res) ? res : [],
                useExternalScope ? scopeSchoolId : '',
                useExternalScope ? scopeCatalogType : undefined
            );
            setTempSubActivityList(rows);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const formik = useFormik({
        initialValues: subActivity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            if (mediaUploading) {
                alert('Please wait for media upload to finish.');
                return;
            }
            if (isSuperAdminScope) {
                values.schooleId = resolveCatalogWriteSchooleId(true, values.schooleId);
            } else {
                values.schooleId = values.schooleId || resolveSchoolIdForClass(
                    addClassList,
                    values.classId,
                    useExternalScope ? scopeSchoolId : '',
                    userDetails
                ) || effectiveSchoolIdForWrite(userDetails, useExternalScope ? scopeSchoolId : '');
                if (!values.schooleId) {
                    alert('Please select a school in the scope filters before adding an exercise.');
                    return;
                }
            }
            values.imageURL = Array.isArray(values.imageURL) ? values.imageURL.filter(Boolean) : [];
            values.videoURL = Array.isArray(values.videoURL) ? values.videoURL.filter(Boolean) : [];
            if (hasCatalogContent(values)) {
                const blocked = await checkParentActivityContent(values.activityId);
                if (blocked) {
                    alert(CONTENT_EXCLUSIVE_HINT + ' Clear them on the List of Activities first.');
                    return;
                }
            }
            if (subActivity._id) {

                SubActivityService.upadeSubActivity(values).then((res) => {

                    handleClose();
                    refreshExerciseCatalog();
                    resetForm()
                    alert("Sub Activity Tabel Updated Successfully.");
                }).catch((err) => {
                    alert(err?.response?.data?.message || err?.message || 'Update failed');
                });
            }
            else {
                SubActivityService.creteSubActivity(values).then((res) => {
                    refreshExerciseCatalog();
                    resetForm();
                    handleClose();
                    alert(" Sub Activity Tabel Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err?.response?.data?.message || err?.message || 'Add failed');
                    })
            }

        },
    });

    const resolveUploadSchooleId = () => {
        if (isSuperAdminScope) {
            return (
                formik.values.schooleId
                || scopeSchoolId
                || resolveSchoolIdForClass(
                    addClassList,
                    formik.values.classId,
                    scopeSchoolId,
                    userDetails
                )
                || ''
            );
        }
        return (
            formik.values.schooleId
            || resolveSchoolIdForClass(
                addClassList,
                formik.values.classId,
                useExternalScope ? scopeSchoolId : '',
                userDetails
            )
            || resolveSchoolId(userDetails)
            || ''
        );
    };

    const uploadExerciseMedia = async (files, type) => {
        if (parentActivityHasContent) {
            alert(CONTENT_EXCLUSIVE_HINT + ' Clear them on the List of Activities first.');
            return;
        }
        const isVideo = type === 'videos';
        const fieldName = isVideo ? 'videos' : 'images';
        const urlField = isVideo ? 'videoURL' : 'imageURL';
        const maxCount = isVideo ? MAX_EXERCISE_VIDEOS : MAX_EXERCISE_IMAGES;
        const current = Array.isArray(formik.values[urlField]) ? formik.values[urlField] : [];

        if (!files.length) return;
        if (current.length + files.length > maxCount) {
            alert(`You can attach at most ${maxCount} ${isVideo ? 'videos' : 'images'}.`);
            return;
        }
        if (isVideo) {
            const oversized = files.filter((f) => f.size > MAX_VIDEO_BYTES);
            if (oversized.length) {
                alert(`Each video must be ${MAX_VIDEO_SIZE_MB} MB or smaller.`);
                return;
            }
        }

        // School is optional for SUPERADMIN (global catalog). Only send when selected.
        const schooleId = resolveUploadSchooleId();

        const formData = new FormData();
        files.forEach((file) => formData.append(fieldName, file));
        if (userDetails?.role === 'SUPERADMIN' && schooleId) {
            formData.append('schooleId', schooleId);
        }

        setMediaUploading(true);
        setMediaUploadProgress({ percent: 0, message: 'Sending files to server…' });
        try {
            const result = await ImagesStoreService.uploadMedia(formData, (prog) => {
                setMediaUploadProgress({
                    percent: prog.percent || 0,
                    message: `Uploading: ${prog.percent || 0}%`,
                });
            });
            const newUrls = isVideo ? (result.videoUrls || []) : (result.imageUrls || []);
            if (!newUrls.length) {
                throw new Error(result.message || 'Upload did not return any URLs.');
            }
            formik.setFieldValue(urlField, [...current, ...newUrls]);
        } catch (err) {
            alert(err?.response?.data?.message || err?.message || 'Upload failed');
        } finally {
            setMediaUploading(false);
            setMediaUploadProgress({ percent: 0, message: '' });
        }
    };

    const handleImagePick = (e) => {
        const files = Array.from(e.target.files || []);
        if (imageInputRef.current) imageInputRef.current.value = '';
        uploadExerciseMedia(files, 'images');
    };

    const handleVideoPick = (e) => {
        const files = Array.from(e.target.files || []);
        if (videoInputRef.current) videoInputRef.current.value = '';
        uploadExerciseMedia(files, 'videos');
    };

    const removeImageAt = (index) => {
        const current = Array.isArray(formik.values.imageURL) ? formik.values.imageURL : [];
        const url = current[index];
        formik.setFieldValue('imageURL', current.filter((_, i) => i !== index));
        if (url) {
            ImagesStoreService.deleteAzureImage({ imageURL: url }).catch(() => {});
        }
    };

    const removeVideoAt = (index) => {
        const current = Array.isArray(formik.values.videoURL) ? formik.values.videoURL : [];
        const url = current[index];
        formik.setFieldValue('videoURL', current.filter((_, i) => i !== index));
        if (url) {
            ImagesStoreService.deleteAzureImage({ imageURL: url }).catch(() => {});
        }
    };
    const getSuperActivityList = (event, obj) => {
        const { listId, role } = buildListSchoolRequest(
            userDetails,
            useExternalScope ? scopeSchoolId : resolveSchoolId(userDetails)
        );
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityById(listId, getsupActList, role).then((res) => {

            setAddSuperActivityList(
                useExternalScope ? filterRowsByCatalogType(res, scopeCatalogType) : res
            );
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const filterActivitys = (activityId) => {
        setfilterActivity(activityId ? String(activityId) : "");
        setExercise("");
    }
    
    // const filterExcDetails = (event) => {
    //     const extId = event?event._id:'';
    //         setExercise(extId);
    //         if (extId) {
    //             const filterValue = temActivitylList.filter(act => act._id === extId);
    //             setTabelList(filterValue);
    //         } else {
    //             setTabelList(temActivitylList);
    //         }

    //     }
    const handleFileChange = (e) => {
        setFile(e.target.files[0]); // Get the selected file
    };

    const handleFileUpload = async () => {
        if (!file) {
            setMessage('Please select a file first.');
            return;
        }

        const formData = new FormData();
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        formData.append('excel', file); // Attach the file to the FormData object
        formData.append('schooleId', userDetails.schooleId);

        try {
            SubActivityService.uploadBulkRecords('/subactivity/data/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Let Axios handle the boundary
                },
            }).then((res) => {
                alert("Data Imported Successfully.")
                refreshExerciseCatalog();
            }).catch((err) => {
                // setError(err.message);
                alert("Failed to upload check file format.")
            });

        } catch (error) {
            console.error('Error uploading file:', error);
            setMessage('Failed to upload file.');
        }
    };
    const filterExcDetails = (event) => {
        const sub = event ? event.value : "";
        setExercise(sub);
    };

    const refreshExercises = () => {
        refreshExerciseCatalog();
        loadFilterActivities(effectiveClassId || null, filterSuperActivity || null);
    };

    const renderExerciseFilters = () => (
        <Grid container spacing={2}>
            {!useExternalScope && (
                <Grid item xs={12} sm={4}>
                    <span className={classes.fieldLabel}>Class</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            name="classId"
                            onChange={(e) => {
                                const nextClassId = e.target.value;
                                setClassId(nextClassId);
                                setFilterSuperActivity("");
                                setfilterActivity("");
                                setExercise("");
                            }}
                            value={classId}
                        >
                            <MenuItem value=""><em>All Classes</em></MenuItem>
                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            )}
            <Grid item xs={12} sm={4}>
                <span className={classes.fieldLabel}>Area Of Work</span>
                <FormControl variant="outlined" size="small" fullWidth>
                    <Select
                        displayEmpty
                        name="filterSuperActivity"
                        value={filterSuperActivity}
                        onChange={(e) => {
                            const nextSuperActivityId = e.target.value;
                            setFilterSuperActivity(nextSuperActivityId);
                            setfilterActivity("");
                            setExercise("");
                            setpg(0);
                        }}
                    >
                        <MenuItem value=""><em>All Areas Of Work</em></MenuItem>
                        {filterSuperActivityList.map(({ _id, superActivityName }) => (
                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
                <span className={classes.fieldLabel}>List Of Activities</span>
                <FormControl variant="outlined" size="small" fullWidth>
                    <Select
                        displayEmpty
                        name="filterActivity"
                        value={filterActivity}
                        onChange={(e) => {
                            setfilterActivity(e.target.value);
                            setExercise("");
                            setpg(0);
                        }}
                    >
                        <MenuItem value=""><em>All Activities</em></MenuItem>
                        {filterActivityList.map(({ _id, activityName }) => (
                            <MenuItem key={_id} value={_id}>{activityName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );

    const renderExerciseTableRow = (sub) => (
        <TableRow key={sub._id} hover>
            {showSchoolColumn && <TableCell>{renderSchoolCell(sub)}</TableCell>}
            <TableCell>
                {sub.classId?.className ? (
                    <Chip size="small" icon={<SchoolIcon style={{ fontSize: 14 }} />} label={sub.classId.className} className={classes.classChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {sub.activityId?.superActivityId?.superActivityName ? (
                    <Chip size="small" label={sub.activityId.superActivityId.superActivityName} className={classes.areaChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {sub.activityId?.activityName ? (
                    <Chip size="small" label={sub.activityId.activityName} className={classes.areaChip} />
                ) : '—'}
            </TableCell>
            <TableCell>
                {sub.isPlaceholder ? (
                    <span className={classes.placeholderText}>No exercises yet</span>
                ) : sub.subActivityName ? (
                    <Chip size="small" label={sub.subActivityName} className={classes.nameChip} />
                ) : '—'}
            </TableCell>
            <TableCell align="center">
                <Tooltip title="Add another exercise for this activity">
                    <IconButton className={classes.iconAction} size="small" onClick={() => addExerciseFromRow(sub)}>
                        <AddIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </TableCell>
            <TableCell>
                <Box display="flex" alignItems="center">
                    {!sub.isPlaceholder && (
                        <Tooltip title="View">
                            <IconButton className={classes.viewIcon} size="small" onClick={() => openView(sub)}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {!sub.isPlaceholder && (
                        canEditDeleteActivityRow(sub) ? (
                            <>
                                <Tooltip title="Edit">
                                    <IconButton className={classes.iconAction} size="small" onClick={() => editSubActivity(sub)}>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <IconButton className={classes.deleteIcon} size="small" onClick={() => deleteSubActivity(sub)}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </>
                        ) : (
                            <>
                                <EditIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be edited" />
                                <DeleteIcon className={classes.disabledIcon} fontSize="small" title="System activities cannot be deleted" />
                            </>
                        )
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );

    const renderExerciseTable = () => (
        <>
            <TableContainer component={Paper} elevation={0} style={{ maxHeight: embedded ? 560 : 520 }}>
                <Table stickyHeader size="small" className="dashboard-table-row-hover">
                    <TableHead>
                        <TableRow>
                            {displayHeaders.map((key) => (
                                <TableCell key={key} className={classes.headCell}>{key}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedTableRows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={displayHeaders.length} align="center" style={{ padding: 48, color: '#7a8aa0' }}>
                                    <Typography variant="body2">
                                        {hasActiveFilters ? emptyExerciseMessage : 'No exercises found.'}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedTableRows.map(renderExerciseTableRow)
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                rowsPerPageOptions={[10, 25, 50, 100]}
                count={paginationCount}
                page={pg}
                onPageChange={handleChangePage}
                rowsPerPage={rpg}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );

    return (
        <>
            {!embedded && (
            <PageTitle title="Exercise"
                button={<Button
                    variant="contained" onClick={() => handleOpen(true)}
                    size="medium"
                    color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Exercise
                </Button>
                }

            />
            )}
            {!embedded && (
            <Box style={{ marginBottom: 16, marginTop: 8, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                <Typography variant="body2" color="textSecondary">
                    By default, all area of work, activities, and exercise are added. If you want to add extra activities, add them here.
                </Typography>
            </Box>
            )}
            {embedded ? (
                <>
                    <Card elevation={0} className={classes.embeddedFiltersCard}>
                        <Box className={classes.filtersHeader}>
                            <Box display="flex" alignItems="center" gridGap={8}>
                                <FilterListIcon style={{ fontSize: 18, color: '#1769d6' }} />
                                <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '0.9rem' }}>
                                    Exercise
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classes.filtersBody}>
                            {renderExerciseFilters()}
                            <Box mt={2} pt={2} style={{ borderTop: '1px solid #eef1f5' }}>
                                <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.85rem', marginBottom: 8 }}>
                                    Bulk import
                                </Typography>
                                <Box display="flex" flexWrap="wrap" alignItems="center" gridGap={12}>
                                    <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
                                    <Button variant="contained" className={classes.primaryBtn} size="small" onClick={handleFileUpload}>
                                        Upload Excel
                                    </Button>
                                    <a
                                        href="https://artistimages.blob.core.windows.net/montestory/Sample (1).xlsx"
                                        download="Sample.xlsx"
                                        style={{ color: '#1769d6', fontSize: '0.85rem', textDecoration: 'none' }}
                                    >
                                        Download sample format
                                    </a>
                                </Box>
                                {message && (
                                    <Typography variant="body2" style={{ marginTop: 8, color: '#7a8aa0' }}>
                                        {message}
                                    </Typography>
                                )}
                            </Box>
                            {hasActiveFilters && subActivitylList.length === 0 && tableRows.length === 0 && (
                                <Box className={classes.emptyFilterBox}>
                                    <Typography className={classes.emptyFilterText}>{emptyExerciseMessage}</Typography>
                                </Box>
                            )}
                        </Box>
                    </Card>
                    <Card elevation={0} className={classes.embeddedTableCard}>
                        <Box className={classes.toolbar}>
                            <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
                                {paginationCount} Exercise{paginationCount === 1 ? '' : 's'}
                            </Typography>
                            <Box display="flex" alignItems="center" gridGap={10}>
                                <Button variant="contained" className={classes.primaryBtn} size="small" startIcon={<AddIcon />} onClick={() => handleOpen(true)}>
                                    Add Exercise
                                </Button>
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    placeholder="Search…"
                                    value={searchTerm}
                                    onChange={(e) => { setSearchTerm(e.target.value); setpg(0); }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Tooltip title="Refresh">
                                    <IconButton className={classes.iconBtnOutlined} size="small" onClick={refreshExercises}>
                                        <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        {renderExerciseTable()}
                    </Card>
                </>
            ) : (
            <>
<Card sx={{ maxWidth: 345 }}>
<Box  style={{margin:"15px"}} >

            <Grid container spacing={2} columns={12} >

  {!useExternalScope && (
  <Grid item xs={12} sm={4} md={4}  >
                                    <span className={classes.fieldLabel}>Class</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            labelId="filter-class-label"
                                            id="filter-class-select"
                                            name="classId"
                                            displayEmpty
                                            onChange={(e) => {
                                                const nextClassId = e.target.value;
                                                setClassId(nextClassId);
                                                setFilterSuperActivity("");
                                                setfilterActivity("");
                                                setExercise("");
                                            }}
                                            value={classId}
                                        >
                                            <MenuItem value="">
                                                <em>All Classes</em>
                                            </MenuItem>

                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}

                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
  )}

                <Grid item xs={12} sm={4} md={4}>
                    <span className={classes.fieldLabel}>Area Of Work</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            id="filter-super-activity"
                            name="filterSuperActivity"
                            value={filterSuperActivity}
                            onChange={(e) => {
                                const nextSuperActivityId = e.target.value;
                                setFilterSuperActivity(nextSuperActivityId);
                                setfilterActivity("");
                                setExercise("");
                                setpg(0);
                            }}
                        >
                            <MenuItem value="">
                                <em>All Areas Of Work</em>
                            </MenuItem>
                            {filterSuperActivityList.map(({ _id, superActivityName }) => (
                                <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                    <span className={classes.fieldLabel}>List Of Activities</span>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            displayEmpty
                            id="filter-activity"
                            name="filterActivity"
                            value={filterActivity}
                            onChange={(e) => {
                                filterActivitys(e.target.value);
                                setpg(0);
                            }}
                        >
                            <MenuItem value="">
                                <em>All Activities</em>
                            </MenuItem>
                            {filterActivityList.map(({ _id, activityName }) => (
                                <MenuItem key={_id} value={_id}>{activityName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                
                <Grid item xs={12}>

                    <input type="file" onChange={handleFileChange} />
                    <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }} onClick={handleFileUpload} >
                        Upload Excel
                    </Button>
                    <br></br>
                    <a
                        href="https://artistimages.blob.core.windows.net/montestory/Sample (1).xlsx" // Replace with your file URL
                        download="Sample.pdf" // Suggested name for the file
                    >
                        download Sample Formate
                    </a>
                    <br></br>
                    {message && <p>{message}</p>}

                    {/* <FormControl variant="filled" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label"> Activities</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                name="activityId"
                                label="Activities"
                                value={filterActivity}
                                onChange={filterActivitys}
                            //  getClassNameList(e) 
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addActivityList.map(({ _id, activityName }) => (
                                    <MenuItem key={_id} value={_id}>{activityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}

                </Grid>
                {/* <Grid item xs={6}> */}
                {/* <div > */}
                {/* <Autocomplete
      id="combo-box-demo"
      options={filterExerciseList}
      getOptionLabel={(option) => option.name}
      
      onChange={(event, newValue) => {
        filterExcDetails(newValue);
      }}
      renderInput={(params) => <TextField {...params} label="Exercise" variant="filled" />}
    /> */}
                {/* <FormControl variant="filled" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label"> Exercise</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                name="activityId"
                                label=" Activities"
                                value={filterExercise}
                                onChange={filterExcDetails}
                            //  getClassNameList(e) 
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {filterExerciseList.map(({ value, name }) => (
                                    <MenuItem key={value} value={value}>{name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
                {/* </div> */}
                {/* </Grid> */}
                
            </Grid>

            {hasActiveFilters && subActivitylList.length === 0 && tableRows.length === 0 && (
                <Box className={classes.emptyFilterBox}>
                    <Typography className={classes.emptyFilterText}>
                        {emptyExerciseMessage}
                    </Typography>
                </Box>
            )}

            </Box>
            </Card >
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        {embedded && (
                            <Box display="flex" justifyContent="flex-end" p={1.5} pb={0}>
                                <Button
                                    variant="contained"
                                    onClick={() => handleOpen(true)}
                                    size="small"
                                    style={{ backgroundColor: 'rgb(15 59 98)', color:"white", textTransform: 'none' }}
                                >
                                    Add Exercise
                                </Button>
                            </Box>
                        )}

                                                <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>

                        <Table stickyHeader size="small" className="dashboard-table-row-hover">
                            <TableHead >
                                <TableRow>
                                    {displayHeaders.map(key => (
                                        <TableCell key={key} className={classes.headCell}>{key}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedTableRows.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={displayHeaders.length}
                                            align="center"
                                            style={{ padding: 48, color: '#7a8aa0' }}
                                        >
                                            <Typography variant="body2">
                                                {hasActiveFilters
                                                    ? emptyExerciseMessage
                                                    : 'No exercises found.'}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedTableRows.map(renderExerciseTableRow)
                                )}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            count={paginationCount}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            </>
            )}
            <Dialog open={open} onClose={handleClose} scroll="paper" PaperProps={{ className: classes.dialogPaper }}>
                <Box className={classes.dialogTitleBar}>
                    <span className={classes.dialogTitleText}>
                        {subActivity._id ? 'Edit Exercise' : 'Add Exercise'}
                    </span>
                    <IconButton size="small" onClick={handleClose}>
                        <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
                    </IconButton>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent className={classes.dialogBody}>
                        <Grid container spacing={2}>
                            {isSuperAdminScope && (
                                <Grid item xs={12}>
                                    <span className={classes.fieldLabel}>School</span>
                                    <FormControl variant="outlined" size="small" fullWidth>
                                        <Select
                                            displayEmpty
                                            name="schooleId"
                                            value={formik.values.schooleId || ''}
                                            onChange={(e) => formik.setFieldValue('schooleId', e.target.value)}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return <em style={{ color: '#8a97a8' }}>All Schools (Default)</em>;
                                                }
                                                const match = addSchoolList.find(
                                                    (s) => normalizeId(s._id) === String(selected)
                                                );
                                                return match ? resolveSchoolLabel(match) : String(selected);
                                            }}
                                        >
                                            <MenuItem value=""><em>All Schools (Default)</em></MenuItem>
                                            {addSchoolList.map((s) => (
                                                <MenuItem key={s._id} value={s._id}>{resolveSchoolLabel(s)}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item xs={12} >
                                <span className={classes.fieldLabel}>Class</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.classId && Boolean(formik.errors.classId)}
                                >
                                    <Select
                                        id="demo-simple-select"
                                        name="classId"
                                        displayEmpty
                                        value={formik.values.classId}
                                        onChange={e => {
                                            formik.handleChange(e);
                                            getSuperActivityList(e);
                                            // When SUPERADMIN has an explicit School field, don't let a
                                            // Class change silently override that choice.
                                            if (isSuperAdminScope) return;
                                            const sid = resolveSchoolIdForClass(
                                                addClassList,
                                                e.target.value,
                                                useExternalScope ? scopeSchoolId : '',
                                                userDetails
                                            );
                                            if (sid) formik.setFieldValue('schooleId', sid);
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Class</em></MenuItem>
                                        {addClassList.map(({ _id, className }) => (
                                            <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} >
                                <span className={classes.fieldLabel}>Area Of Work</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                >
                                    <Select
                                        id="superActivityName"
                                        name="superActivityId"
                                        displayEmpty
                                        onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                        value={formik.values.superActivityId}
                                    >
                                        <MenuItem value=""><em>Select Area Of Work</em></MenuItem>
                                        {addSuperActivityList.map(({ _id, superActivityName }) => (
                                            <MenuItem key={_id} value={_id}>{superActivityName}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.superActivityId && formik.errors.superActivityId && (
                                        <FormHelperText>{formik.errors.superActivityId}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>List Of Activities</span>
                                <FormControl
                                    variant="outlined" size="small" fullWidth
                                    error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                >
                                    <Select
                                        id="activityName"
                                        name="activityId"
                                        displayEmpty
                                        value={formik.values.activityId}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            checkParentActivityContent(e.target.value);
                                        }}
                                    >
                                        <MenuItem value=""><em>Select Activity</em></MenuItem>
                                        {addActivityList.map(({ _id, activityName }) => (
                                            <MenuItem key={_id} value={_id}>{activityName}</MenuItem>
                                        ))}
                                    </Select>
                                    {formik.touched.activityId && formik.errors.activityId && (
                                        <FormHelperText>{formik.errors.activityId}</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>Exercise</span>
                                <TextField
                                    fullWidth size="small" variant="outlined"
                                    autoFocus
                                    id="subActivityName"
                                    name="subActivityName"
                                    type="text"
                                    value={formik.values.subActivityName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.subActivityName && Boolean(formik.errors.subActivityName)}
                                    helperText={formik.touched.subActivityName && formik.errors.subActivityName}
                                />
                            </Grid>
                            {parentActivityHasContent && (
                                <Grid item xs={12}>
                                    <Box className={classes.exclusiveWarnBox}>
                                        <Typography className={classes.exclusiveWarnText}>
                                            {CONTENT_EXCLUSIVE_HINT} This activity already has notes or media — clear them on List of Activities to add here.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>Notes</span>
                                <TextField
                                    fullWidth size="small" variant="outlined"
                                    id="notes"
                                    name="notes"
                                    multiline
                                    minRows={3}
                                    maxRows={8}
                                    disabled={parentActivityHasContent}
                                    value={formik.values.notes || ''}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <span className={classes.fieldLabel}>Images &amp; Videos</span>
                                <Typography className={classes.mediaHint}>
                                    Upload up to {MAX_EXERCISE_IMAGES} images and {MAX_EXERCISE_VIDEOS} videos
                                    (max {MAX_VIDEO_SIZE_MB} MB each).
                                </Typography>
                                <input
                                    ref={imageInputRef}
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    hidden
                                    onChange={handleImagePick}
                                />
                                <input
                                    ref={videoInputRef}
                                    type="file"
                                    accept="video/*,.mp4,.webm,.mov,.m4v"
                                    multiple
                                    hidden
                                    onChange={handleVideoPick}
                                />
                                <Box className={classes.mediaActions}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className={classes.mediaPickBtn}
                                        startIcon={<ImageIcon />}
                                        disabled={mediaUploading || parentActivityHasContent}
                                        onClick={() => imageInputRef.current && imageInputRef.current.click()}
                                    >
                                        Add Images
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className={classes.mediaPickBtn}
                                        startIcon={<VideocamIcon />}
                                        disabled={mediaUploading || parentActivityHasContent}
                                        onClick={() => videoInputRef.current && videoInputRef.current.click()}
                                    >
                                        Add Videos
                                    </Button>
                                    {mediaUploading && <CircularProgress size={20} style={{ color: '#1769d6' }} />}
                                </Box>
                                {mediaUploading && (
                                    <Box className={classes.uploadProgressWrap}>
                                        <Typography variant="caption" style={{ color: '#46566b' }}>
                                            {mediaUploadProgress.message || 'Uploading…'}
                                        </Typography>
                                        <LinearProgress
                                            variant="determinate"
                                            value={mediaUploadProgress.percent || 0}
                                            style={{ marginTop: 4, borderRadius: 4, height: 6 }}
                                        />
                                    </Box>
                                )}
                                {(formik.values.imageURL || []).length > 0 && (
                                    <>
                                        <Typography className={classes.fieldLabel} style={{ marginTop: 8 }}>
                                            Images ({formik.values.imageURL.length})
                                        </Typography>
                                        <Box className={classes.mediaPreviewGrid}>
                                            {formik.values.imageURL.map((url, index) => (
                                                <Box key={`img-${index}-${url}`} className={classes.mediaPreviewItem}>
                                                    <img src={url} alt={`Exercise ${index + 1}`} className={classes.mediaThumb} />
                                                    <IconButton
                                                        size="small"
                                                        className={classes.mediaRemoveBtn}
                                                        disabled={mediaUploading || parentActivityHasContent}
                                                        onClick={() => removeImageAt(index)}
                                                    >
                                                        <DeleteIcon style={{ fontSize: 16, color: '#b91c1c' }} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}
                                {(formik.values.videoURL || []).length > 0 && (
                                    <>
                                        <Typography className={classes.fieldLabel} style={{ marginTop: 12 }}>
                                            Videos ({formik.values.videoURL.length})
                                        </Typography>
                                        <Box className={classes.mediaPreviewGrid}>
                                            {formik.values.videoURL.map((url, index) => (
                                                <Box key={`vid-${index}-${url}`} className={classes.mediaPreviewItem}>
                                                    <video
                                                        src={url}
                                                        className={classes.mediaThumb}
                                                        muted
                                                        preload="metadata"
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        className={classes.mediaRemoveBtn}
                                                        disabled={mediaUploading || parentActivityHasContent}
                                                        onClick={() => removeVideoAt(index)}
                                                    >
                                                        <DeleteIcon style={{ fontSize: 16, color: '#b91c1c' }} />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </Box>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogFooter}>
                        <Button onClick={handleClose} className={classes.cancelBtn} disabled={mediaUploading}>Cancel</Button>
                        <Button type="submit" variant="contained" className={classes.saveBtn} disabled={mediaUploading}>
                            {mediaUploading ? 'Uploading…' : (subActivity._id ? 'Update' : 'Add')}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog open={viewOpen} onClose={closeView} fullWidth maxWidth="sm">
                <DialogTitle>Exercise Details</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2"><b>Class:</b> {viewRow?.classId?.className || ''}</Typography>
                    <Typography variant="body2">
                        <b>Area Of Work:</b>{" "}
                        {viewRow?.activityId && viewRow.activityId.superActivityId
                            ? (viewRow.activityId.superActivityId.superActivityName || '')
                            : ''}
                    </Typography>
                    <Typography variant="body2"><b>Activity:</b> {viewRow?.activityId?.activityName || ''}</Typography>
                    <Typography variant="body2"><b>Exercise:</b> {viewRow?.subActivityName || ''}</Typography>
                    <Box mt={2}>
                        <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>Notes</Typography>
                        <Paper style={{ padding: 10, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
                            <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
                                {viewRow?.notes ? String(viewRow.notes) : "—"}
                            </Typography>
                        </Paper>
                    </Box>
                    {(Array.isArray(viewRow?.imageURL) && viewRow.imageURL.filter(Boolean).length > 0) && (
                        <Box mt={2}>
                            <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>
                                Images ({viewRow.imageURL.filter(Boolean).length})
                            </Typography>
                            <Box display="flex" flexWrap="wrap" style={{ gap: 10 }}>
                                {viewRow.imageURL.filter(Boolean).map((url, index) => (
                                    <a key={`view-img-${index}`} href={url} target="_blank" rel="noopener noreferrer">
                                        <img
                                            src={url}
                                            alt={`Exercise ${index + 1}`}
                                            style={{
                                                width: 96,
                                                height: 96,
                                                objectFit: 'cover',
                                                borderRadius: 8,
                                                border: '1px solid #e6eaf0',
                                            }}
                                        />
                                    </a>
                                ))}
                            </Box>
                        </Box>
                    )}
                    {(Array.isArray(viewRow?.videoURL) && viewRow.videoURL.filter(Boolean).length > 0) && (
                        <Box mt={2}>
                            <Typography variant="body2" style={{ fontWeight: 900, marginBottom: 6 }}>
                                Videos ({viewRow.videoURL.filter(Boolean).length})
                            </Typography>
                            <Box display="flex" flexDirection="column" style={{ gap: 10 }}>
                                {viewRow.videoURL.filter(Boolean).map((url, index) => (
                                    <video
                                        key={`view-vid-${index}`}
                                        src={url}
                                        controls
                                        style={{
                                            width: '100%',
                                            maxHeight: 240,
                                            borderRadius: 8,
                                            backgroundColor: '#0f2d4d',
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeView} style={{ backgroundColor: "rgb(15 59 98)", color: "white" }} variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => {
                    setDeleteConfirmOpen(false);
                    setPendingDelete(null);
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>localhost:3000 says</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        Are you sure you want to delete{" "}
                        <b>"{pendingDelete?.subActivityName ? String(pendingDelete.subActivityName) : "this exercise"}"</b>?
                        <br />
                        <br />
                        This action cannot be undone. All associated data will be permanently removed.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={confirmDelete}
                        style={{ backgroundColor: "rgb(15 59 98)", color: "white" }}
                        variant="contained"
                    >
                        OK
                    </Button>
                    <Button
                        onClick={() => {
                            setDeleteConfirmOpen(false);
                            setPendingDelete(null);
                        }}
                        style={{ backgroundColor: "#f3e5e5", color: "#0f3b62" }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

